import { render, staticRenderFns } from "./ArticleTags.vue?vue&type=template&id=5465ca64&scoped=true&"
import script from "./ArticleTags.vue?vue&type=script&lang=js&"
export * from "./ArticleTags.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTags.vue?vue&type=style&index=0&id=5465ca64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5465ca64",
  null
  
)

export default component.exports